import { classNames } from '~/utils/classNames';

interface Props {
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'xl';
}

const SIZE_CLASSES: Record<NonNullable<Props['size']>, string> = {
  xs: 'w-4 h-4 p-0.25 rounded',
  sm: 'w-5 h-5 p-0.25 rounded',
  md: 'w-6 h-6 p-0.5 rounded-md',
  xl: 'w-20 h-20 rounded-[20px] p-2.5',
};

export function StripeLogo({ className, size = 'md' }: Props) {
  return (
    <div
      className={classNames(
        'border border-bolt-elements-borderColor flex items-center justify-center bg-[#635BFF]',
        SIZE_CLASSES[size],
        className,
      )}
    >
      <span className="i-bx:bxl-stripe size-full text-white" />
    </div>
  );
}
